
export default {
  props: {
    type: {type: String, default: 'icon'}, // 'logo' | 'icon' | 'big-icon'
    size: {type: String, default: '2.4rem'},
    color: {type: String, default: 'var(--brand-500)'},
  },
  computed: {
    max_logo() {
      return this.$store.max_style
    },
    logo() {
      return this.max_logo ? '/assets/max-logo.svg' : '/assets/logo.svg'
    },
    stroke(){
      return this.max_logo || this.type !== 'icon' ? undefined : this.color
    },
    icon(){
      if (this.max_logo) return 'custom/max-icon'
      if (this.type === 'big-icon') return 'custom/logo9'
      if (this.type === 'fat-icon') return 'custom/g-logo-fat'
      return 'g-logo'
    },
  }
}
